import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import DoctorCard from "@/components/landing/DoctorCard";
import { LandingNav, LandingHero, LandingCta, LandingFooter } from "@/components/landing/LandingSections";

export default function Landing() {
  const [doctors, setDoctors] = useState([]);
  const navigate = useNavigate();
  const setBookingDoctor = (d) => navigate(`/book?doctor=${d.id}`);

  useEffect(() => {
    api.get("/public/doctors").then((r) => setDoctors(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <LandingNav />
      <LandingHero doctorCount={doctors.length} />

      <section id="doctors" className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs font-medium uppercase tracking-wider text-teal-600 mb-3">Our Specialists</div>
          <h2 className="font-head text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Highlighted Doctors</h2>
          <p className="mt-4 text-slate-500">Get to know our specialists — their expertise and where you can consult them.</p>
        </div>
        <div data-testid="landing-doctor-grid" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {doctors.map((d, i) => <DoctorCard key={d.id} d={d} index={i} onBook={setBookingDoctor} />)}
        </div>
      </section>

      <LandingCta />
      <LandingFooter />
    </div>
  );
}
